export const m = {
  // SideMenu.vue
  Dashboard: '儀表板',
  General: '基本設定',
  User: '使用者管理',
  Announcement: '公告管理',
  System_Config: '系統設定',
  Judge_Server: 'Judge 伺服器',
  Prune_Test_Case: '測資',
  Problem: '試題',
  Problem_List: '試題列表',
  Create_Problem: '增加題目',
  Export_Import_Problem: '匯入匯出題目',
  Contest: '比賽',
  Contest_List: '比賽列表',
  Create_Contest: '建立比賽',
  // User.vue
  User_User: '使用者',
  Import_User: '匯入使用者',
  Generate_User: '生成使用者',
  // User.vue-dialog
  User_Info: '使用者資訊',
  User_Username: '使用者名稱',
  User_Real_Name: '真實姓名',
  User_Email: '使用者 E-mail',
  User_New_Password: '使用者密碼',
  User_Type: '帳號類型',
  Problem_Permission: '試題權限',
  Two_Factor_Auth: '兩步驟驗證',
  Is_Disabled: '是否可用',
  // Announcement.vue
  General_Announcement: '公告',
  Announcement_Title: '標題',
  Announcement_Content: '內容',
  Announcement_Status: '狀態',
  Announcement_Push: '推送',
  // Conf.vue
  SMTP_Config: 'SMTP 設定',
  Server: '伺服器',
  Port: '連接埠',
  Email: 'E-mail',
  Password: '密碼',
  Website_Config: '網站設定',
  Base_Url: 'Base Url',
  Name: '名稱',
  Shortcut: '簡稱',
  Footer: '頁尾',
  Allow_Register: '是否允許註冊',
  Submission_List_Show_All: '顯示全部題目的提交',
  // JudgeServer.vue
  Judge_Server_Token: 'Judge 伺服器 Token',
  Judge_Server_Info: 'Judge 伺服器',
  IP: 'IP',
  Judger_Version: 'Judge 版本',
  Service_URL: '伺服器 URL',
  Last_Heartbeat: '上一次活動訊號',
  Create_Time: '建立時間',
  // PruneTestCase
  Test_Case_Prune_Test_Case: '精簡測資',
  // Problem.vue
  Display_ID: '顯示 ID',
  Title: '題目',
  Description: '描述',
  Input_Description: '輸入描述',
  Output_Description: '輸出描述',
  Samples_Explanation: '樣例解釋',
  Time_Limit: '時間限制',
  Memory_limit: '記憶體限制',
  Difficulty: '難度',
  Visible: '是否可見',
  Languages: '可選程式語言',
  Input_Samples: '輸入範例',
  Output_Samples: '輸出範例',
  Add_Sample: '加入範例',
  Code_Template: '程式碼模板',
  Special_Judge: 'Special Judge',
  Use_Special_Judge: '使用 Special Judge',
  Special_Judge_Code: 'Special Judge Code',
  SPJ_language: 'SPJ language',
  Compile: '編譯',
  TestCase: '測資',
  Type: '測試類型',
  Input: '輸入',
  Output: '輸出',
  Score: '分數',
  Hint: '提示',
  Source: '來源',
  Problem_Source: '題目來源',
  Problem_Difficulty: '題目難度',
  Algorithm_Tags: '算法標簽',
  // Contest.vue
  ContestTitle: '標題',
  ContestDescription: '描述',
  Contest_Start_Time: '開始時間',
  Contest_End_Time: '結束時間',
  Contest_Password: '密碼',
  Contest_Rule_Type: '規則',
  Real_Time_Rank: '即時排名',
  Contest_Status: '狀態',
  Allowed_IP_Ranges: '允許的 IP 範圍',
  Analysis_File: '解析文件',
  CIDR_Network: 'CIDR Network',
  // Dashboard.vue
  Last_Login: '最後登入狀態',
  System_Overview: '系統狀況',
  DashBoardJudge_Server: 'Judge 伺服器',
  HTTPS_Status: 'HTTPS 狀態',
  Force_HTTPS: '強制 HTTPS',
  CDN_HOST: 'CDN HOST',
  ReviewDetails: '回顧查看提交詳情'
}
